var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "app-browse",
        {
          attrs: {
            "button-bar-items": _vm.buttonBarItems,
            "controls-disabled": _vm.controlsDisabled,
            "data-source": _vm.dataSource,
            "search-enabled": _vm.searchEnabled,
            "selected-items": _vm.selectedItems,
            "ignore-scanner": _vm.scanToSelectShouldBeOn,
            "url-query-params": "",
          },
          on: {
            openEditGroupsModal: function ($event) {
              return _vm.openEditGroupsModal()
            },
            openEditPriceModal: function ($event) {
              return _vm.openEditPriceModal()
            },
            openUploadCsvModal: function ($event) {
              return _vm.openUploadCsvModal()
            },
            recomputeStockClicked: function ($event) {
              return _vm.recomputeStockClicked()
            },
            markForLabelPrinter: function ($event) {
              return _vm.markForLabelPrinter()
            },
            unmarkForLabelPrinter: function ($event) {
              return _vm.unmarkForLabelPrinter()
            },
            editPriceSettings: function ($event) {
              return _vm.editPriceSettings()
            },
            openStockMovement: function ($event) {
              return _vm.openStockMovement()
            },
            openPrintAutomaticLabelsModal: function ($event) {
              return _vm.openPrintAutomaticLabelsModal()
            },
            "col-click-result": (result, value) =>
              _vm.onColClick(result, value),
            state: function ($event) {
              _vm.browseState = $event
            },
          },
        },
        [
          _vm._t("header", null, { slot: "header" }),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("components.stock.newStock"),
                  expression: "$ct('components.stock.newStock')",
                },
              ],
              attrs: {
                slot: "extra-buttons",
                disabled: !_vm.hasStockModule || _vm.selectedItems.length != 1,
              },
              on: {
                click: function ($event) {
                  _vm.editStockModal = true
                },
              },
              slot: "extra-buttons",
            },
            [_c("w-fa", { attrs: { icon: "cube" } })],
            1
          ),
          _vm._t("extra-buttons", null, { slot: "extra-buttons" }),
          _vm._t("top", null, { slot: "top" }),
          _vm._t("bottom", null, { slot: "bottom" }),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.uploadCSVModal,
            callback: function ($$v) {
              _vm.uploadCSVModal = $$v
            },
            expression: "uploadCSVModal",
          },
        },
        [
          _c("app-import-csv-modal", {
            attrs: { "group-id": _vm.browseId },
            on: {
              close: function ($event) {
                _vm.uploadCSVModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.editGroupsModal,
            callback: function ($$v) {
              _vm.editGroupsModal = $$v
            },
            expression: "editGroupsModal",
          },
        },
        [
          _vm.editGroupsModal
            ? _c("app-product-group-edit-card", {
                on: {
                  close: function ($event) {
                    _vm.editGroupsModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.editPriceSettingsModal,
            callback: function ($$v) {
              _vm.editPriceSettingsModal = $$v
            },
            expression: "editPriceSettingsModal",
          },
        },
        [
          _vm.editPriceSettingsModal
            ? _c("app-product-edit-sell-prices-modal", {
                attrs: { products: _vm.selectedItems },
                on: {
                  saved: function ($event) {
                    return _vm.onProductSellPricesEditSaved()
                  },
                  close: function ($event) {
                    _vm.editPriceSettingsModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.editStockModal } },
        [
          _c("app-stock-edit-single", {
            attrs: { value: _vm.selectedItems[0] },
            on: {
              save: function ($event) {
                return _vm.onStockSaved()
              },
              cancel: function ($event) {
                _vm.editStockModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: { value: _vm.$route.path != "/products", "full-height": "" },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              "created-new-product": function ($event) {
                return _vm.updateView()
              },
            },
          }),
        ],
        1
      ),
      _vm.browseState && _vm.createAutomaticLabelsModalOpen
        ? _c("app-create-automatic-labels-modal", {
            attrs: { "selected-items": _vm.browseState.selectedItems },
            on: {
              close: function ($event) {
                _vm.createAutomaticLabelsModalOpen = false
              },
            },
          })
        : _vm._e(),
      _vm.setGroupModalOpen
        ? _c("app-set-group-modal", {
            attrs: { "selected-items": _vm.selectedItems },
            on: {
              close: function ($event) {
                _vm.setGroupModalOpen = false
              },
              refresh: function ($event) {
                return _vm.updateView()
              },
            },
          })
        : _vm._e(),
      _vm.setSizeTableModalOpen
        ? _c("app-set-size-table-modal", {
            attrs: { "selected-items": _vm.selectedItems },
            on: {
              close: function ($event) {
                _vm.setSizeTableModalOpen = false
              },
              refresh: function ($event) {
                return _vm.updateView()
              },
            },
          })
        : _vm._e(),
      _vm.quickEditSellPriceModal
        ? _c("app-product-quick-edit-sell-price", {
            attrs: {
              product: _vm.quickEditSellPriceModal.product,
              category: _vm.quickEditSellPriceModal.category,
            },
            on: {
              close: function ($event) {
                _vm.quickEditSellPriceModal = null
              },
              refresh: function ($event) {
                return _vm.refreshProduct(_vm.quickEditSellPriceModal.product)
              },
            },
          })
        : _vm._e(),
      _vm.quickEditSellPriceIncVatModal
        ? _c("app-product-quick-edit-sell-price-inc-vat", {
            attrs: {
              product: _vm.quickEditSellPriceIncVatModal.product,
              category: _vm.quickEditSellPriceIncVatModal.category,
            },
            on: {
              close: function ($event) {
                _vm.quickEditSellPriceIncVatModal = null
              },
              refresh: function ($event) {
                return _vm.refreshProduct(
                  _vm.quickEditSellPriceIncVatModal.product
                )
              },
            },
          })
        : _vm._e(),
      _vm.toQuickEditMainSupplierCatalogPriceProduct
        ? _c("app-product-quick-edit-main-supplier-buy-catalog-price", {
            attrs: { product: _vm.toQuickEditMainSupplierCatalogPriceProduct },
            on: {
              close: function ($event) {
                _vm.toQuickEditMainSupplierCatalogPriceProduct = null
              },
              refresh: function ($event) {
                return _vm.refreshProduct(
                  _vm.toQuickEditMainSupplierCatalogPriceProduct
                )
              },
            },
          })
        : _vm._e(),
      _vm.toQuickEditMainSupplierNettoPriceProduct
        ? _c("app-product-quick-edit-main-supplier-buy-netto-price", {
            attrs: { product: _vm.toQuickEditMainSupplierNettoPriceProduct },
            on: {
              close: function ($event) {
                _vm.toQuickEditMainSupplierNettoPriceProduct = null
              },
              refresh: function ($event) {
                return _vm.refreshProduct(
                  _vm.toQuickEditMainSupplierNettoPriceProduct
                )
              },
            },
          })
        : _vm._e(),
      _vm.toQuickEditGroupProduct
        ? _c("app-product-quick-edit-group", {
            attrs: { value: _vm.toQuickEditGroupProduct },
            on: {
              close: function ($event) {
                _vm.toQuickEditGroupProduct = null
              },
              refresh: function ($event) {
                return _vm.refreshProduct(_vm.toQuickEditGroupProduct)
              },
            },
          })
        : _vm._e(),
      _vm.showPriceListsModal
        ? _c("app-price-list-browse-wrapper", {
            on: {
              close: function ($event) {
                _vm.updateView(), (_vm.showPriceListsModal = false)
              },
            },
          })
        : _vm._e(),
      _vm.excelMapperOpen
        ? _c("app-excel-mapper", {
            on: {
              close: function ($event) {
                _vm.excelMapperOpen = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }